import { useContext } from 'react';
import SessionContext from '../contexts/SessionContext';
import type { SessionContextValue } from '../contexts/SessionContext';

const useSession = (): SessionContextValue => useContext(SessionContext);

export default useSession;
